import { create } from "zustand";

export const useWholesale = create((set, get) => ({
  /** @var string private|wholesale */
  active: false,
  setActive: (active = true) => set({ active }),
}));